import script from "./AutoAIShiftGenerator.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoAIShiftGenerator.vue?vue&type=script&setup=true&lang=ts"

import "./AutoAIShiftGenerator.vue?vue&type=style&index=0&id=1cc66d9e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc66d9e"]])

export default __exports__